import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DevComponent} from './dev/dev.component';
import {GuideComponent} from './guide/guide.component';

const routes: Routes = [
  { path: '', redirectTo: '/dev', pathMatch: 'full'},
  { path: 'dev', component: DevComponent },
  { path: '**', redirectTo: '/dev' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
